import { useQuery } from '@tanstack/react-query';
import { fetchRSimsPagination } from '../RSimApi/rSimApi';
import { rSimProductsQueries } from '../utils/rsimProductsQueries';
import { useAtomValue } from 'jotai';
import {
  pageFilterAtom,
  rowsPerPageFilterAtom,
  rsimFiltersAtom,
  rsimSortingAtomWithStorage,
} from 'atoms/filters/rsim-products';
import { useValidatedSearchId } from 'src/common/components/Filters/hooks/useValidatedSearchId';

export const useRSimProductsPagination = (refetchOnWindowFocus?: boolean) => {
  const rowsPerPage = useAtomValue(rowsPerPageFilterAtom);
  const page = useAtomValue(pageFilterAtom);
  const sorting = useAtomValue(rsimSortingAtomWithStorage);
  const filters = useAtomValue(rsimFiltersAtom);

  const {
    searchText,
    chosenIdType,
    lastActiveProfile,
    lastUpdateTime,
    tags,
    connectionId,
    orderNumber,
    simulateOutage,
    accounts,
    productCodes,
    eidFrom,
    eidTo,
    subscriptionStatus,
    mobileNetworkOperator,
    mnoNames,
    mobileNetworkOperatorId,
  } = filters;

  const { search } = useValidatedSearchId(searchText);
  const queryKey = rSimProductsQueries.pagination({
    sorting,
    page,
    rowsPerPage,
    accounts,
    productCodes,
    chosenIdType,
    connectionId,
    lastActiveProfile,
    orderNumber,
    searchText: search,
    simulateOutage,
    tags,
    eidFrom,
    eidTo,
    lastUpdateTime,
    subscriptionStatus,
    mobileNetworkOperator,
    mnoNames,
    mobileNetworkOperatorId,
  });

  const { data, isLoading, status } = useQuery({
    queryKey: queryKey,
    refetchOnWindowFocus,
    queryFn: () =>
      fetchRSimsPagination(
        {
          searchText: search,
          chosenIdType,
          connectionId,
          orderNumber,
          simulateOutage,
          lastActiveProfile,
          tags,
          accounts,
          productCodes,
          lastUpdateTime,
          eidFrom,
          eidTo,
          subscriptionStatus,
          mobileNetworkOperator,
          mnoNames,
          mobileNetworkOperatorId,
        },
        sorting,
      ),
  });

  return {
    data: status === 'success' ? data?.totalNumberOfItems : -1,
    isLoading,
  };
};
